import { render, staticRenderFns } from "./OhodonticTest.vue?vue&type=template&id=1270a6d6&scoped=true&"
import script from "./OhodonticTest.vue?vue&type=script&lang=js&"
export * from "./OhodonticTest.vue?vue&type=script&lang=js&"
import style0 from "./OhodonticTest.vue?vue&type=style&index=0&id=1270a6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1270a6d6",
  null
  
)

export default component.exports